module.exports = __webpack_public_path__ + "static/key-ancestors-0d979ea1f4b3652241f84a15626964da.webp";